import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import Trial1PdfPage from '../components/Trial1PdfPage'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(Trial1PdfPage)
